import React, { JSX, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useParams, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Button, Box, Typography } from '@mui/material';
import AdminPage from './AdminPage';
import VotingPage from './VotingPage';
import ResultsPage from './ResultsPage';
import SessionManager from './SessionManager';

// Helper to get session from params and pass to children
const SessionWrapper = ({ children }: { children: (session: string) => JSX.Element }) => {
  const { session } = useParams<{ session: string }>();
  if (!session) return <Navigate to="/" replace />; // fallback if session missing
  return children(session);
};

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleSessionSelect = (sessionName: string) => {
    navigate(`/${sessionName}`);
  };

  return <SessionManager onSessionSelect={handleSessionSelect} />;
};

const NavBar: React.FC = () => {
  const location = useLocation();
  // Try to extract session from the current URL
  const match = location.pathname.match(/^\/([^/]+)/);
  const session = match && match[1] && match[1] !== ':' ? match[1] : '';
  
  return (
    <AppBar position="absolute" sx={{ bgcolor: 'transparent', boxShadow: 'none' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{ fontWeight: 400, color: '#fff', fontSize: '0.8rem' }}>
          
        </Typography>
        <Box sx={{ display: 'flex', gap: 1,fontSize: '0.8rem' }}>
          {session && (
            <>
              <Button
                component={Link}
                to={`/${session}`}
                sx={{
                  color: '#fff',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                  textTransform: 'none',
                  fontWeight: 500, fontSize: '0.8rem'
                }}
              >
                Vote
              </Button>
              <Button 
                component={Link}
                to={`/${session}/admin`}
                sx={{
                  color: '#fff',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                  textTransform: 'none',
                  fontWeight: 500, fontSize: '0.8rem'
                }}
              >
                Admin
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

const App: React.FC = () => (
  <Router>
    <NavBar />
    <Routes>
      <Route path=":" element={<HomePage />} />
      <Route path=":session" element={
        <SessionWrapper>{session => <VotingPage session={session} />}</SessionWrapper>
      } />
      <Route path=":session/admin" element={
        <SessionWrapper>{session => <AdminPage session={session} />}</SessionWrapper>
      } />
      <Route path=":session/results" element={
        <SessionWrapper>{session => <ResultsPage session={session} />}</SessionWrapper>
      } />
      {/* Redirect root to home page */}
      <Route path="/" element={<HomePage />} />
    </Routes>
  </Router>
);

export default App;
